

$(document).ready(
  () => {
    $(window).scroll(function () {
    // This is then function used to detect if the element is scrolled into view
    function elementScrolled(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $(elem).offset().top;
        return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
    }

          
  
  const nodeList = document.querySelectorAll(".custom-animated");
  for (let i = 0; i < nodeList.length; i++) {
   
    if (elementScrolled(nodeList[i])) {
      console.log("animated")
       
        nodeList[i].classList.add('u--zoomOut');
    }
  }


});
  }
)

